import {AvailableAppointment} from '../models/appointment.model';

export const MOCK_AVAILABLE_APPOINTMENTS: AvailableAppointment[] = [
	{
		date: '2023-10-01',
		time: [
			{time: '09:00', date_time_local: '2023-10-01T09:00-08:00'},
			{time: '10:00', date_time_local: '2023-10-01T10:00-08:00'},
			{time: '11:00', date_time_local: '2023-10-01T11:00-08:00'},
		],
	},
	{
		date: '2023-10-02',
		time: [
			{time: '01:00', date_time_local: '2023-10-02T01:00-08:00'},
			{time: '02:00', date_time_local: '2023-10-02T02:00-08:00'},
			{time: '03:00', date_time_local: '2023-10-02T03:00-08:00'},
		],
	},
	{
		date: '2023-10-03',
		time: [
			{time: '08:30', date_time_local: '2023-10-03T08:30-08:00'},
			{time: '09:30', date_time_local: '2023-10-03T09:30-08:00'},
			{time: '10:30', date_time_local: '2023-10-03T10:30-08:00'},
		],
	},
	{
		date: '2023-10-04',
		time: [],
	},
	{
		date: '2023-10-05',
		time: [
			{time: '08:00', date_time_local: '2023-10-03T08:00-08:00'},
			{time: '06:00', date_time_local: '2023-10-03T06:00-08:00'},
		],
	},
	{
		date: '2023-10-07',
		time: [
			{time: '12:00', date_time_local: '2023-10-07T12:00-08:00'},
			{time: '12:30', date_time_local: '2023-10-07T12:30-08:00'},
			{time: '12:50', date_time_local: '2023-10-07T12:50-08:00'},
			{time: '14:00', date_time_local: '2023-10-07T14:00-08:00'},
			{time: '12:55', date_time_local: '2023-10-07T12:55-08:00'},
		],
	},
	{
		date: '2023-11-03',
		time: [
			{time: '08:30', date_time_local: '2023-10-07T08:30-08:00'},
			{time: '20:00', date_time_local: '2023-10-07T20:00-08:00'},
		],
	},
	{
		date: '',
		time: [],
	},
	{
		date: '2024-01-23',
		time: [
			{time: '09:45', date_time_local: '2023-10-07T09:45-08:00'},
			{time: '11:00', date_time_local: '2023-10-07T11:00-08:00'},
			{time: '13:15', date_time_local: '2023-10-07T13:15-08:00'},
			{time: '14:10', date_time_local: '2023-10-07T14:10-08:00'},
			{time: '15:30', date_time_local: '2023-10-07T15:30-08:00'},
		],
	},
];

export const MOCK_ADDITIONAL_APPOINTMENTS: AvailableAppointment[] = [
	{
		date: '2024-01-24',
		time: [
			{time: '06:45', date_time_local: '2023-10-07T06:45-08:00'},
			{time: '10:20', date_time_local: '2023-10-07T10:20-08:00'},
			{time: '13:25', date_time_local: '2023-10-07T13:25-08:00'},
			{time: '14:05', date_time_local: '2023-10-07T14:05-08:00'},
			{time: '17:30', date_time_local: '2023-10-07T17:30-08:00'},
		],
	},
	{
		date: '2024-01-25',
		time: [
			{time: '06:45', date_time_local: '2023-10-07T06:45-08:00'},
			{time: '10:20', date_time_local: '2023-10-07T10:20-08:00'},
			{time: '16:30', date_time_local: '2023-10-07T16:30-08:00'},
			{time: '17:00', date_time_local: '2023-10-07T17:00-08:00'},
			{time: '17:20', date_time_local: '2023-10-07T17:20-08:00'},
		],
	},
];
